import React, { useState } from "react";
import { Button, MSelect } from "components/Shared";
import { BreakOption } from "./CalendarHelpers";
import "./CalendarBreakSelectionForm.scss";

interface Props {
  onSaveClicked: (breakOption: BreakOption) => void,
  breakOptions: BreakOption[],
};

const CalendarBreakSelectionForm = ({ breakOptions, onSaveClicked }: Props) => {
  const [selectedBreakOption, setSelectedBreakOption] = useState(breakOptions[Math.floor(breakOptions.length / 2)]);

  const mapBreakOptionToDropdown = (b: BreakOption) => ({ label: b.display, value: b });

  return (
    <div className="break-selection-form">
      <div className="break-text">Please select a time to take a break for this entry of time</div>
      <MSelect
        className="break-options"
        value={mapBreakOptionToDropdown(selectedBreakOption)}
        options={breakOptions.map(mapBreakOptionToDropdown)}
        onChange={b => setSelectedBreakOption(b.value)}
        isClearable={false}
        isSearchable={false}
      />
      <div className="break-ok-button">
        {/* @ts-ignore button props issue */}
        <Button onClick={() => onSaveClicked(selectedBreakOption)}>Ok</Button>
      </div>
    </div>
  );
};

export default CalendarBreakSelectionForm;
